function myFund(){
// some output for debugging  

const form_arr = document.querySelectorAll('[data-v-c0bcd8-s=""]');
  console.log(form_arr[1]);
  
  // debugging block
  let text  = "";
  for (let i = 0; i < form_arr.length; i++) {
    console.log(form_arr[i]);
  }

  form_arr[1].dispatchEvent(new Event('click'));

} //end


function myHideDiv(){

const frequencyFrame = document.querySelectorAll('[data-v-c0bcd8=""]'); 
  const frequencyButton = document.querySelectorAll('[data-v-c0bcd8-s=""]'); 
  // hide the div
frequencyFrame[1].style.display = "none";
  frequencyButton[0].style.display = "none";
document.getElementById("continue_button").style.display = "none";
} // end myFunction


function stageCanvass(){

  const select_arr = document.querySelector('select');

  // debugging block
  let text  = "";
  for (let i = 0; i < select_arr.length; i++) {
    //console.log(select_arr[i]);
  }

console.log('menu length:'+select_arr.length); 
mySelector(select_arr.length); // set the stage to open up the procucts
  
} //end function



function myCounter(str){

// Build an array of the add product buttons
const buttonsElement = document.querySelectorAll('[data-v-e31dd0=""][data-v-a381d9=""] > button'); 
  
let text  = "";
var cnt_selected = 0;
var total_prod = 0;
for (let i = 0; i < buttonsElement.length; i++) {
    //console.log(buttonsElement[i]);
    total_prod++;
    if(buttonsElement[i].className === 'rb-btn rb-btn-remove'){
      
      cnt_selected++;
    }
}
//console.log('selected:'+cnt_selected);
//console.log('total:'+total_prod);
  
var remaining = total_prod-cnt_selected;
console.log('selected:'+cnt_selected);
return cnt_selected; // return the count of selected products
  
  

} // end function


function myDone(){

let theCount = myCounter();
  console.log(theCount);
  mySelector(theCount);

document.getElementById("done_button").style.display = "none"; 
  document.getElementById("continue_button").style.display = "block";
}


function mySelector(str){

    
const select_arr = document.querySelectorAll('[data-v-c0bcd8=""]'); // index 5 is the <select> element
const memVariantList = document.querySelector("select"); //Gives me the <select> <options> in an array 
// 
// onClick event needs to change the value number.
var StIndex = str+1;
var Slindex = StIndex-2;
memVariantList[Slindex].value = Slindex;
memVariantList[Slindex].selected = true;

select_arr[5].dispatchEvent(new Event('change'));


 
} // end mySelector



//window.onload = function() {
window.addEventListener('load', function () {

  stageCanvass(); 
  myHideDiv();
  console.log("stageCanvass ran!");
  
    var head = document.getElementsByTagName("body")[0];
    var script = document.createElement("script"); 

  alert("Ready!")
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", "https://static.rechargecdn.com/assets/js/widget.min.js?shop=the-wellness-comp.myshopify.com");

    head.addEventListener("load", function(event) {
        if (event.target.nodeName === "SCRIPT")
        {
          console.log("loaded list: " + event.target.nodeName);
          // defining string
let string1 = event.target.getAttribute("src");
// 
//let index = string1.match("https://static.rechargecdn.com/assets/js/widget.min.js?shop=the-wellness-comp.myshopify.com");
//let index = string1.match("rechargecdn");
let index = string1.match("wb8wcvxi");          
//let index = string1.match("googleapis");
alert(index);
          if(Array.isArray(index)){
            //
            stageCanvass(); 
            myHideDiv();
            console.log("stageCanvass ran!");
          }
          
          console.log("Script loaded: " + event.target.getAttribute("src"));
        }
    }, true);

    
})







